// 작명 상태가 균일하지 않아 추후 업데이트가 편리하도록 컴포넌트 로직에서 데이터 로직을 분리.
// 자동완성이 가능하도록 JSDOC 사용 << 필요시 Refactor 로 이름 고치시면 됩니다

import { API_URL } from "./common";
import axios from "axios";
import { TimeData } from "./Time";
import { useState, useEffect } from 'react';

// 기본 오더된 필드
export const OrderedItemFieldKeys = ['rent', 'surtax', 'electric', 'gas'];
export const OrderedItemResFieldKeys = ['resRent', 'resSurtax', 'resElectric', 'resGas'];
export const OrderedItemFieldNames = ['임대료', '부가세', '전기세', '도시가스'];

/**
 * @class PaymentData
 * represent single company
 */
export class PaymentData {
    /** @public @property {string} id */
    id
    /** @public @type {TimeData} */
    createTime
    /** @public @property {string} rent */
    rent
    /** @public @property {string} surtax */
    surtax
    /** @public @property {string} electric */
    electric
    /** @public @property {string} gas */
    gas
    /** @public @property {string} company */
    company
    /** @public @property {string} room */
    room
    /** @public @property {string} total */
    total

    /** @public @type {TimeData?} */
    resRent
    /** @public @type {TimeData?} */
    resElectric
    /** @public @type {TimeData?} */
    resSurtax
    /** @public @type {TimeData?} */
    resGas

    // {
//     "id": 1,
//     "companyName": "test_company",
//     "room_number": "999",
//     "rent": 102300,
//     "surtax": 10000,
//     "elec_bill": 134520,
//     "gas_bill": 19900,
//     "total_amount": 266720,
//     "create_time": "2024-12-07",
//     "res_rent": null,
//     "res_surtax": null,
//     "res_elec": null,
//     "res_gas": null
// },

    constructor({ id, createTime, rent, surtax, electric, gas, company, room, total, resElectric, resGas, resRent, resSurtax }) {
        this.createTime = createTime;
        this.rent = rent;
        this.surtax = surtax;
        this.electric = electric;
        this.gas = gas;
        this.company = company;
        this.room = room;
        this.id = id;
        this.total = total;
        this.resElectric = resElectric;
        this.resGas = resGas;
        this.resRent = resRent;
        this.resSurtax = resSurtax;
    }

    /** @returns {PaymentData} */
    static fromObject(obj) {
        const {res_elec, res_gas, res_rent, res_surtax, id, create_time, rent, surtax, elec_bill, gas_bill, companyName, room_number, total_amount} = obj;
        return new PaymentData({
            id,
            createTime: TimeData.fromText(create_time),
            rent,
            surtax,
            electric: elec_bill,
            gas: gas_bill,
            company: companyName,
            room: room_number,
            total: total_amount,
            resElectric: res_elec ? TimeData.fromText(res_elec) : null,
            resGas: res_gas ? TimeData.fromText(res_gas) : null,
            resRent: res_rent ? TimeData.fromText(res_rent) : null,
            resSurtax: res_surtax ? TimeData.fromText(res_surtax) : null,
        });
    }

    /** @returns {[PaymentData]|null} */
    static use() {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [data, setData] = useState(null);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(()=>{
            axios.get(API_URL + "/v2/payment/all", {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }).then(response => {
                setData(response.data.map(obj => PaymentData.fromObject(obj)))
            }).catch(error => {
                console.error("Error fetching data:" + error);
                alert("데이터를 가져오는 중 문제가 발생했습니다.");
            });
        },[]);
        return data;
    }
}
